import { authorize, postRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

export async function submitResourceBooking(data) {
  const backendURL = `${AWS_API_URL}/resources`;

  return postRequest(backendURL, { data }, await authorize());
}
